<template>
  <g>
    <g clip-path="url(#clip0_40_2050)">
      <path
        d="M8.61998 15.5002L15.38 15.5002L12 18.8802L8.61998 15.5002ZM11.29 20.2902C11.68 20.6802 12.31 20.6802 12.7 20.2902L17.29 15.7002C17.92 15.0802 17.48 14.0002 16.59 14.0002L7.41998 14.0002C6.52998 14.0002 6.07998 15.0802 6.70998 15.7102L11.29 20.2902ZM7.40998 10.0002L16.59 10.0002C17.48 10.0002 17.93 8.92021 17.3 8.29021L12.71 3.70021C12.32 3.31021 11.69 3.31021 11.3 3.70021L6.70998 8.29021C6.07998 8.92021 6.51998 10.0002 7.40998 10.0002Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_40_2050">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(24 0.000244141) rotate(90)"
        />
      </clipPath>
    </defs>
  </g>
</template>
